import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/element'
import './plugins/vueAreaLinkage'
import './plugins/vueTinymce'
import './assets/css/reset.css'
import 'amfe-flexible'
import 'default-passive-events'
import request from './request'
import banksdata from './assets/js/bank.js'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/font/iconfont.css';
import 'babel-polyfill'  //兼容
import  'jquery'
import qs from 'qs'
Vue.prototype.$qs = qs;
Vue.prototype.$axios = request;

Vue.use(ElementUI);
Vue.config.productionTip = false
if (store.state.USER_ID) {
	store.commit('SET_USER_ID', '')
}

new Vue({
	router,
	store,
	render: h => h(App),
	beforeCreate() {
		Vue.prototype.$bus = this
	}
}).$mount('#app')